import React from "react";

export default function FirstLoad() {
  return <div>FirstLoad</div>;
}
